<template>
  <!-- Skeleton until the whitelabel color loads, so the brand color never flashes -->
  <div v-if="!colorReady" class="antecip-hero antecip-hero--skeleton">
    <div class="antecip-hero__content">
      <span class="sk sk-eyebrow"></span>
      <span class="sk sk-title"></span>
      <span class="sk sk-text"></span>
    </div>
    <div class="antecip-hero__art antecip-hero__art--skeleton"></div>
  </div>

  <div v-else class="antecip-hero" :style="{ background: heroBg }">
    <div class="antecip-hero__content">
      <span class="antecip-hero__eyebrow">Antecipação de Recebíveis</span>
      <h2 class="antecip-hero__title">Venda a crédito e receba à vista</h2>
      <p class="antecip-hero__text">
        Antecipe suas vendas realizadas a crédito de forma mais simples,
        rápida e segura.
      </p>
      <p class="antecip-hero__brand">
        {{ partner === 'establishment' ? account.fantasy_name : partnerName }}
      </p>
    </div>
    <div class="antecip-hero__art">
      <v-icon color="white" size="72">account_balance_wallet</v-icon>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "AnticipationsHeader",
  created() {
    this.$store.dispatch("account/getAccount");
  },
  computed: {
    ...mapGetters({
      account: "account/account",
      partner: "account/partner",
      partnerName: "account/partnerName",
      color: "account/color",
    }),
    colorReady() {
      return !!this.color;
    },
    heroBg() {
      const c = this.color || "#1976D2";
      return `linear-gradient(135deg, ${c} 0%, ${this.shade(c, -22)} 100%)`;
    },
  },
  methods: {
    shade(hex, percent) {
      const h = String(hex).replace("#", "");
      if (h.length !== 6) return hex;
      const num = parseInt(h, 16);
      const amt = Math.round(2.55 * percent);
      const clamp = (v) => Math.max(0, Math.min(255, v));
      const r = clamp((num >> 16) + amt);
      const g = clamp(((num >> 8) & 0x00ff) + amt);
      const b = clamp((num & 0x0000ff) + amt);
      return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
    },
  },
};
</script>

<style scoped>
.antecip-hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-radius: 18px;
  padding: 26px 28px;
  margin: 8px;
  color: #fff;
  box-shadow: 0 10px 26px rgba(13, 71, 161, 0.24);
}

.antecip-hero__content {
  min-width: 0;
}

.antecip-hero__eyebrow {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 1px;
  opacity: 0.85;
}

.antecip-hero__title {
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;
  margin: 6px 0 8px;
}

.antecip-hero__text {
  font-size: 14px;
  opacity: 0.92;
  margin: 0 0 10px;
  max-width: 460px;
}

.antecip-hero__brand {
  font-size: 13px;
  font-weight: 600;
  opacity: 0.9;
  margin: 0;
}

.antecip-hero__art {
  flex-shrink: 0;
  width: 96px;
  height: 96px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.16);
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Skeleton state (shown until whitelabel color loads) */
.antecip-hero--skeleton {
  background: #eef1f5;
  box-shadow: none;
}
.antecip-hero__art--skeleton {
  background: rgba(0, 0, 0, 0.06);
}
.sk {
  display: block;
  border-radius: 8px;
  background: linear-gradient(90deg, #e3e7ec 25%, #eef1f5 37%, #e3e7ec 63%);
  background-size: 400% 100%;
  animation: sk-shimmer 1.4s ease infinite;
}
.sk-eyebrow {
  width: 160px;
  height: 12px;
  margin-bottom: 12px;
}
.sk-title {
  width: 280px;
  height: 24px;
  margin-bottom: 12px;
}
.sk-text {
  width: 360px;
  max-width: 100%;
  height: 14px;
}
@keyframes sk-shimmer {
  0% { background-position: 100% 0; }
  100% { background-position: 0 0; }
}

@media screen and (max-width: 600px) {
  .antecip-hero {
    flex-direction: column;
    text-align: center;
    padding: 22px 20px;
  }
  .antecip-hero__title {
    font-size: 20px;
  }
  .antecip-hero__text {
    font-size: 13px;
  }
}
</style>
